import React, { useEffect, useState } from "react";
import { TitleText } from "../../template/AccountBalance";
import { Hrule, LoadingSpinner } from "../../pages/AddUserPage/AddUser";
import { RadioOption, SubStep } from "./Stepper";
import { styled } from "styled-components";
import TextArea from "../Accounts/TextArea";
import CustomSelect from "../Accounts/SelectComponent";
import InputContainer from "../Accounts/InputContainer";
import Button from "../Button/Button";
import RadioBtnWithSubText from "./RadioBtnWithSubText";
import { Formik } from "formik";
import { useSelector } from "react-redux";
import { RootState } from "../../store/rootReducer";
import {
  fetchFormResponses,
  setActiveStep,
  setActiveSubStep,
} from "../../store/onBoarding/onBoardingSlice";
import { returnStepperData } from "../../utils/returnStepperData";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store";
import { updateUserOnboardingFormResponse } from "../../graphql/mutations/onBoarding";
import { useMutation } from "@apollo/client";
import {
  createValidationSchema,
  returnFormInitialValues,
} from "../../utils/createValidationSchema";
import { toast } from "react-toastify";

const Forms: React.FC<SubStep> = ({
  label,
  subTitle,
  secondSubTitle,
  formFields,
  hasOneCol,
  buttonText,
}) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  const { onBoardingData, activeStep, activeSubStep } = useSelector(
    (state: RootState) => state.OnBoarding
  );

  const { formResponses, loading: loadingUserResponse } = useSelector(
    (state: RootState) => state.OnBoarding
  );

  const modifiedStepperData = returnStepperData(onBoardingData);
  const [showList, setShowList] = useState<Record<string, any>>({});
  const [formValues, setFormValues] = useState<Record<string, any> | null>(
    null
  );

  const handleSelectOption = (name: string, option: string) => {
    setFormValues((prevValues) => ({ ...(prevValues || {}), [name]: option }));
  };
  const handleShowList = (name: string, state: boolean) => {
    setShowList((prevValues) => ({ ...prevValues, [name]: state }));
  };
  const totalSubSteps =
    modifiedStepperData?.[activeStep - 1]?.subSteps?.length || 0;
  const totalSteps = modifiedStepperData?.length;

  const [
    updateUserOnboardingFormResponseMutation,
    { loading: formResponseLoading },
  ] = useMutation(updateUserOnboardingFormResponse);

  const validationSchema = createValidationSchema(formFields);

  const userFormResponses = formResponses?.formResponses;

  const isLastStep = activeStep === totalSteps;

  useEffect(() => {
    !loadingUserResponse &&
      setFormValues({
        ...returnFormInitialValues(formFields),
        ...userFormResponses,
      });
  }, [loadingUserResponse, userFormResponses]);

  useEffect(() => {
    dispatch(fetchFormResponses());
  }, [dispatch, pathname]);

  return (
    <div style={{ width: "100%" }}>
      <TitleText>{label}</TitleText>
      <Hrule />
      {formValues ? (
        <>
          <Formik
            initialValues={formValues}
            validationSchema={validationSchema}
            onSubmit={async (
              values,
              { setSubmitting, setTouched, validateForm }
            ) => {
              setSubmitting(true);

              const errors = await validateForm();
              if (Object.keys(errors).length) {
                setTouched(
                  Object.keys(errors).reduce(
                    (acc, key) => ({ ...acc, [key]: true }),
                    {}
                  )
                );
                setSubmitting(false);
              } else {
                try {
                  const response =
                    await updateUserOnboardingFormResponseMutation({
                      variables: {
                        formResponses: values,
                        reviewed: isLastStep,
                      },
                    });
                  if (response) {
                    dispatch(fetchFormResponses());
                    if (isLastStep) {
                      navigate("/dashboard");
                      return;
                    }
                    if (activeSubStep === totalSubSteps) {
                      dispatch(setActiveStep(activeStep + 1));
                      // navigate(
                      //   `/dashboard/complete-account-set-up/${modifiedStepperData[activeStep].subSteps[0].path}`
                      // );
                      window.location.href = `/dashboard/complete-account-set-up/${modifiedStepperData[activeStep].subSteps[0].path}`;
                      dispatch(setActiveSubStep(1));
                      return;
                    }

                    dispatch(setActiveSubStep(activeSubStep + 1));
                    // navigate(
                    //   `/dashboard/complete-account-set-up/${
                    //     modifiedStepperData[activeStep - 1].subSteps[
                    //       activeSubStep
                    //     ].path
                    //   }`
                    // );
                    window.location.href = `/dashboard/complete-account-set-up/${
                      modifiedStepperData[activeStep - 1].subSteps[
                        activeSubStep
                      ].path
                    }`;
                  }
                } catch (error) {
                  toast.error((error as any)?.message);
                }
              }
            }}
          >
            {(formik) => (
              <FormWrapper>
                <SubTitleText>{subTitle}</SubTitleText>
                {secondSubTitle && (
                  <SubTitleText>{secondSubTitle}</SubTitleText>
                )}
                <FormDiv
                  $hasOneCol={hasOneCol as boolean}
                  onSubmit={formik.handleSubmit}
                >
                  {formFields.map((field) =>
                    field.type === "textArea" ? (
                      <TextArea
                        label={field.label as string}
                        onChange={(e) => {
                          formik.handleChange(e);
                          const { name, value } = e.target;
                          setFormValues((prevValues) => ({
                            ...prevValues,
                            [name]: value,
                          }));
                        }}
                        name={field.name}
                        width={"100%"}
                        noMargin
                      />
                    ) : field.type === "select" ? (
                      <CustomSelect
                        selectedOption={formValues[field.name]}
                        showList={showList[field.name]}
                        options={field.options as string[]}
                        selectOption={(option) => {
                          handleSelectOption(field.name, option);
                          formik.handleChange({
                            target: {
                              name: field.name,
                              value: option,
                            },
                          });
                        }}
                        placeHolder={field.placeholder as string}
                        toggleShowList={() =>
                          handleShowList(field.name, !showList[field.name])
                        }
                        label={field.label as string}
                        width={hasOneCol ? "100%" : "48%"}
                      />
                    ) : field.type === "input" ? (
                      <>
                        <InputContainer
                          info={!!field.info}
                          name={field.name}
                          infoMessage={field.info}
                          label={field.label as string}
                          type={field.inputType as string}
                          placeholder={field.placeholder as string}
                          onChange={(e) => {
                            formik.handleChange(e);
                            const { name, value } = e.target;
                            setFormValues((prevValues) => ({
                              ...prevValues,
                              [name]: value,
                            }));
                          }}
                          width={hasOneCol ? "100%" : "48%"}
                          disabled={field.disabled}
                          icon={field.icon}
                          telInput={field.inputType === "tel"}
                          value={formValues[field.name] || ""}
                          maxLength={field.inputType === "tel" ? 10 : undefined}
                        />
                      </>
                    ) : (
                      <RadioBtnWithSubText
                        radioOption={field.radioOption as RadioOption}
                        onClickOption={(name, state) => {
                          formik.handleChange({
                            target: {
                              name,
                              value: state,
                            },
                          });
                          setFormValues((prevValues) => ({
                            ...prevValues,
                            [name]: state,
                          }));
                        }}
                        activeButton={formValues[field.name]}
                        label={field.label as string}
                        name={field.name}
                      />
                    )
                  )}
                  <div className="btn-wrapper">
                    <Button
                      green
                      id={""}
                      title={
                        formResponseLoading ? (
                          <LoadingSpinner small $auto />
                        ) : (
                          `${isLastStep ? "Submit" : buttonText || "Continue"}`
                        )
                      }
                      padding={"10px 30px"}
                      type="submit"
                      disabled={!formik.isValid}
                    />
                  </div>
                </FormDiv>
              </FormWrapper>
            )}
          </Formik>
        </>
      ) : (
        <LoadingSpinner />
      )}
    </div>
  );
};

export default Forms;

export const FormWrapper = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-height: 53vh;
  overflow: auto;

  .btn-wrapper {
    padding-top: 2rem;
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  @media only screen and (max-width: 767px) {
    padding: 0.5rem;
  }
`;
export const FormDiv = styled.form<{ $hasOneCol: boolean }>`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  width: ${({ $hasOneCol }) => ($hasOneCol ? "50%" : "100%")};
  @media only screen and (max-width: 767px) {
    width: 100%;
  }
`;

export const SubTitleText = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: #5e5e5e;
  width: 67%;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 1rem;
`;
